import React from 'react';
import MenuTop404 from '../Menu/MenuTop404';
import Footer from '../Footer';
import { Container } from './styles';




const Main: React.FC = ({ children }) => {
  return (
    <Container>
      <MenuTop404 />
         {children}
       <Footer />
    </Container>
  )
}

export default Main;